// extracted by css-extract-rspack-plugin
export default {"negative":"Negative-module__negative__LPUuQ","copilotRun":"Negative-module__copilotRun__fcVdz"};